module.exports = __webpack_public_path__ + "img/blueBackTick.9bbf10dc.svg";